import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { MwButton, MwSpinnerButton, NoDataFound } from "../ui";
import { useInvoice } from "../../hooks";
import { useFetch, useCurrent } from "../../hooks";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";
import CardHeadeWithActions from "../ui/CardHeadeWithActions";
import { MdAccountBalance } from "react-icons/md";
import { IoCreate } from "react-icons/io5";
// import toast, { Toaster } from 'react-hot-toast'

const Sales_Invoice_Requisition = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { currentTenantId, currentCompanyId, currentBranchId } = useCurrent();
  const { formatter } = useInvoice();
  const [t, i18next] = useTranslation("global");
  const isRTL = i18next.dir() === "rtl";

  const baseUrl = `${process.env.REACT_APP_INV_API_SERVER_BASE_URL}/invoices/not-delivered/${currentTenantId}/${currentCompanyId}/${currentBranchId}`;
  console.log("URL:", baseUrl);
  const { data: apiResponse, loading: dataLoading } = useFetch(baseUrl);
  console.log("data:", apiResponse);

  const [localData, setLocalData] = useState([]);
  const [links, setLinks] = useState([]);

  useEffect(() => {
    if (apiResponse) {
      setLocalData(apiResponse || []);
      setLinks(apiResponse.links || []);
    }
  }, [apiResponse]);

  const handleCreateReceiveOrder = (invoiceId) => {
    navigate(`/${params.tenant}/invoices-requisition/create/${invoiceId}`);
  };

  return (
    <>
      <CardHeadeWithActions
        icon={<MdAccountBalance size={18} />}
        title={t('deleted.sales_to_receipt_management')}
      ></CardHeadeWithActions>

      {!dataLoading ? (
        <div className="flex-1  rounded-xl p-2">
          {localData && localData.length > 0 ? (
            <ul>
              <li className="flex justify-between p-2 text-xs border-b  rounded-xl bg-[#EBF9D9] text-[#251658] font-bold">
                <div className="w-8 px-2 text-center">#</div>
                <div className="w-28 text-center">
                  {t("invoice.invoiceNo")}{" "}
                </div>
                <div className="flex-1"> {t("invoices.customerName")}</div>
                <div className="w-40  "> {t("invoices.invoiceAmount")} </div>
                <div className="w-28 px-2 text-center">{t("reports.Date")}</div>
                <div className="w-56 px-1 text-center">
                  {t("table.actions")}
                </div>
              </li>

              <div className="h-[calc(100vh-175px)] overflow-auto pb-3  text-[#251658]">
                {localData.map((result, index) => (
                  <div
                    key={result.id}
                    className="flex justify-between items-center border-b hover:bg-slate-100 hover:font-bold p-2 text-xs"
                  >
                    <div className="flex-1">
                      <div className="flex justify-between">
                        <div className="w-8 px-2 text-center">{index + 1}</div>
                        <div className="w-28 text-center">{result.inv_no}</div>
                        <div className="flex-1 flex justify-between items-center">
                          <span>{result.customer_name || "مورد عام"}</span>
                        </div>
                        <div className="w-48  text-center ">
                          {formatter.format(result.net_amount)}
                        </div>
                        <div className="w-48 text-center  items-center">
                          {result.inv_date?.substring(0, 11) || "غير متوفر"}
                        </div>
                      </div>
                    </div>
                    <div className="w-44 px-5 flex items-center text-start">
                      <IoCreate className="text-green-500 dark:text-green-500  font-medium" />
                      <div
                        onClick={() => handleCreateReceiveOrder(result.id)}
                        className="font-medium text-green-500 dark:text-green-500 py-1 px-2 rounded-3xl cursor-pointer"
                      >
                        {t("invoices.Create_Receipt_Order")}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* {links.length > 0 && (
                                <div id="dataLinks" className="list-none flex gap-3 border-t pt-3 px-5 cursor-default">
                                    {links.length > 3 && links.map((item, i) => (
                                        <li
                                            key={i}
                                            className='hover:font-bold'
                                            // onClick={() => item?.url && paginateHandler(item?.url.replace('http', 'https'))}
                                        >
                                            {parse(item.label)}
                                        </li>
                                    ))}
                                </div>
                            )} */}
            </ul>
          ) : (
            <NoDataFound msg={t("requisition.no_received_sales")} />
          )}
        </div>
      ) : (
        <div className="flex-1">
          <MwSpinnerButton withLabel={false} isFullCenter={true} />
        </div>
      )}
    </>
  );
};

export default Sales_Invoice_Requisition;
